import { Injectable } from '@angular/core';
import * as SecureLS from 'secure-ls'
@Injectable()
export class SidebarService {
  visible: boolean;
  private ls;
  constructor() {
    this.visible = true;
    this.ls = new SecureLS({ encodingType: "rc4", isCompression: true });
  }

  hideSidebar() {
    this.visible = false;
  }

  showSidebar() {
    this.visible = true;
  }

  getSidebarVisibility() {
    return this.visible;
  }

  setContest(contests): void {

    this.ls.set('contests', { data: JSON.stringify(contests) });
  }

  getContest() {
    let contests = this.ls.get("contests");
    if (contests !== "") {
      let contestsData = JSON.parse(contests.data);
      return contestsData;
    }
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/app/service/sidebar.service.ts